import React from 'react';
import {
  IonGrid,
  IonRow,
  IonCol,
  IonButton,
  IonText
} from '@ionic/react';
import { Card } from '@tremor/react';
import { OCCUPANT_TYPE } from '../../utils/constants';

export default function OverpaymentsCard({
  totalOverpaid = 0,
  overpayCount = 0,
  currency = '',
  onView = () => {},
  options = {}
}) {
  const accountLabel = options?.userAccountType === OCCUPANT_TYPE ? 'Tenant' : 'Member';

  return (
    <Card className="mb-3" style={{ borderRadius: '10px' }}>
      <div className="ion-padding ion-text-center">
          {accountLabel} Advance Payments ({currency})
      </div>
      <IonGrid>
          <IonRow className="ion-justify-content-center ion-text-center">
            <IonCol size="12" sizeMd='8' className="text-center order-1 order-md-1">
              <IonText color="primary" style={{ fontSize: '1.8rem' }}>
                {totalOverpaid.toLocaleString('en-US')}
              </IonText>
              <p className="ion-margin-top ion-no-margin">
                {overpayCount} {accountLabel.toLowerCase()}{overpayCount === 1 ? '' : 's'} with advance payments
              </p>
            </IonCol>
            <IonCol size="12" sizeMd='4' className='ion-margin-top text-center order-2 order-md-2'>
              <IonButton expand="block" fill="outline" onClick={onView}>
                View Details
              </IonButton>
            </IonCol>
          </IonRow>
        </IonGrid>
    </Card>
  );
} 